import script from "./welcome-page-handle.vue?vue&type=script&setup=true&lang=js"
export * from "./welcome-page-handle.vue?vue&type=script&setup=true&lang=js"

import "./welcome-page-handle.vue?vue&type=style&index=0&id=ff53bbec&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff53bbec"]])

export default __exports__